import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { vi } from './vi';
import { en } from './en';

// Merge pages translations with main translations
const viTranslation = vi;
const enTranslation = en;


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'vi',
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      vi: { translation: viTranslation },
      en: { translation: enTranslation },
    },
  });

export default i18n;
